import { SVGProps } from 'react';

export const DocumentsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.5 10.5L5.625 8.32501C5.7473 8.08212 5.93334 7.87704 6.16321 7.73172C6.39307 7.5864 6.65812 7.50631 6.93 7.50001H15M15 7.50001C15.2291 7.49961 15.4553 7.55171 15.6612 7.65232C15.8671 7.75293 16.0472 7.89938 16.1877 8.08041C16.3282 8.26145 16.4253 8.47226 16.4716 8.69668C16.518 8.92109 16.5123 9.15314 16.455 9.37501L15.3 13.875C15.2164 14.1987 15.0272 14.4852 14.7622 14.689C14.4972 14.8928 14.1718 15.0023 13.8375 15H3C2.60218 15 2.22064 14.842 1.93934 14.5607C1.65804 14.2794 1.5 13.8978 1.5 13.5V3.75001C1.5 3.35219 1.65804 2.97066 1.93934 2.68935C2.22064 2.40805 2.60218 2.25001 3 2.25001H5.925C6.17586 2.24755 6.42334 2.30805 6.64477 2.42598C6.86621 2.5439 7.05453 2.71548 7.1925 2.92501L7.8 3.82501C7.93658 4.03241 8.12252 4.20265 8.34113 4.32046C8.55973 4.43828 8.80417 4.49997 9.0525 4.50001H13.5C13.8978 4.50001 14.2794 4.65805 14.5607 4.93935C14.842 5.22066 15 5.60219 15 6.00001V7.50001Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
